const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <>
            <div style={styles.darkBG} onClick={onClose} />
            <div style={styles.centered}>
                <div style={styles.modal}>
                    {children}
                </div>
            </div>
        </>
    );
};

const styles = {
    darkBG: {
        position: 'fixed',
        left: '0',
        top: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: '1000'
    },
    centered: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: '1001'
    },
    modal: {
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        width: '400px',
        textAlign: 'center'
    }
};

export default Modal;